import Clipboard from '@stimulus-components/clipboard'

export default class ClipboardController extends Clipboard {

}
